export default {
    SET_SEARCH_KEYWORD: 'SET_SEARCH_KEYWORD',
    SEARCH_KEYWORD: 'SEARCH_KEYWORD',
    GET_SEARCH_DATA: 'GET_SEARCH_DATA',
    SEARCH_DATA: 'SEARCH_DATA',
    CURRENT_FILTER: 'CURRENT_FILTER',
    CHANGE_FILTER: 'CHANGE_FILTER'
}


// WEBPACK FOOTER //
// ./constants/search.js